import { render, staticRenderFns } from "./EmailComposeModal.vue?vue&type=template&id=4dd85326"
import script from "./EmailComposeModal.vue?vue&type=script&lang=js"
export * from "./EmailComposeModal.vue?vue&type=script&lang=js"
import style0 from "./EmailComposeModal.vue?vue&type=style&index=0&id=4dd85326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports